// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
import Popper from "popper.js";

window.jQuery = $;
window.$ = $;

require("bootstrap");
const WOW = require('wowjs/dist/wow.min')
window.wow = new WOW.WOW();
window.wow.init();

// Remove this demo code, that's only here to show how the .env file works!
/*if (process.env["HELLO"]) {
  console.log(`Hello ${process.env.HELLO}!`);
}*/

require('./welcome.js')
//require('is-in-viewport')

$.fn.inView = function(){
  if(!this.length)
    return false;
  var rect = this.get(0).getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );

};

$( document ).ready(function() {
  $('a.scroll').on('click', function (e) {
    var href = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(href).offset().top
    }, 'medium', function () {
      /*var $div = $( '#welcome' );
      if ($div.is(':in-viewport')) {
        $('.navbar').clearQueue()
        $('.navbar').animate({'opacity' : '0'}, 300)
      }
      else {
        $('.navbar').clearQueue()
        $('.navbar').animate({'opacity' : '1'}, 300)
      }*/
    });
    e.preventDefault();
  });

 /* $(window).scroll(function() {
    var $div = $( '#welcome' );
    if ($div.is(':in-viewport')) {
      $('.navbar').clearQueue()
      $('.navbar').animate({'opacity' : '0'}, 300)
    }
    else {
      $('.navbar').clearQueue()
      $('.navbar').animate({'opacity' : '1'}, 300)
    }
  });*/
});


